export enum DeviceType {
  MOBILE = 'mobile',
  PC = 'pc',
}

export enum BrowserType {
  WECHAT = 'wechat',
  ALIPAY = 'alipay',
  QQ = 'qq',
  OTHER = 'other',
}

export const isMobile = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  const isSmallScreen = window.innerWidth <= 768

  return hasTouchScreen && isSmallScreen
}

export const isPC = (): boolean => {
  return !isMobile()
}

export const isWeChat = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false
  }

  return /MicroMessenger/i.test(window.navigator.userAgent)
}

export const isAlipay = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false
  }

  return /AlipayClient/i.test(window.navigator.userAgent)
}

export const isQQ = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false
  }

  const ua = window.navigator.userAgent.toLowerCase()
  return /qq\//i.test(ua) || /qqbrowser/i.test(ua)
}

export const getDeviceType = (): DeviceType => {
  return isMobile() ? DeviceType.MOBILE : DeviceType.PC
}

export const getBrowserType = (): BrowserType => {
  if (isWeChat()) return BrowserType.WECHAT
  if (isAlipay()) return BrowserType.ALIPAY
  if (isQQ()) return BrowserType.QQ
  return BrowserType.OTHER
}

export const getDeviceInfo = () => {
  return {
    deviceType: getDeviceType(),
    browserType: getBrowserType(),
    isMobile: isMobile(),
    isPC: isPC(),
    isWeChat: isWeChat(),
    isAlipay: isAlipay(),
    isQQ: isQQ(),
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : '',
  }
}
